import React from 'react';
import { Box, Fade, Grid, IconButton, Slide } from '@material-ui/core';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import defaultLocales from 'globals/locales/default';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import FsFormGridWrapper from 'ui-elements/form-elements/FsFormGridWrapper';
import FsFormGridItem from 'ui-elements/form-elements/FsFormGridItem';

export interface WebOriginSingleRowDataProps {
  id: number;
  origin: string;
  comment: string;
}

export interface WebOriginSingleRowProps extends WebOriginSingleRowDataProps {
  onRemove?: () => void;
  onChange?: ({ id, origin, comment }: WebOriginSingleRowDataProps) => void;
  isOnlyOneRow?: boolean;
}

const WebOriginSingleRow: React.FC<WebOriginSingleRowProps> = ({
  id,
  comment = '',
  origin = '',
  onRemove,
  onChange,
  isOnlyOneRow,
}) => {
  const handleClick = async () => {
    if (onRemove) onRemove();
  };

  const handleChange = async (newValue: WebOriginSingleRowDataProps) => {
    if (onChange) onChange({ ...newValue });
  };

  return (
    <Slide direction="left" in timeout={300}>
      <Box>
        <FsFormGridWrapper>
          <FsFormGridItem>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <FsSimpleInput
                  fsVariant="outlined"
                  fullWidth
                  label={defaultLocales.origin}
                  placeholder={defaultLocales.http}
                  value={origin}
                  onChange={(e) =>
                    handleChange({ id, comment, origin: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FsSimpleInput
                  fsVariant="outlined"
                  fullWidth
                  label={defaultLocales.comment}
                  placeholder={defaultLocales.yourComment}
                  value={comment}
                  onChange={(e) =>
                    handleChange({ id, origin, comment: e.target.value })
                  }
                />
              </Grid>
            </Grid>
          </FsFormGridItem>
          <FsFormGridItem style={{ flexGrow: 0 }}>
            <Fade in={!isOnlyOneRow} timeout={300}>
              <Box display="flex" alignItems="center">
                <IconButton onClick={handleClick} disabled={isOnlyOneRow}>
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </Box>
            </Fade>
          </FsFormGridItem>
        </FsFormGridWrapper>
      </Box>
    </Slide>
  );
};

export default WebOriginSingleRow;
